import { CreateManualAccountData } from "../Data/CreateManualAccount.data";
import { ManualAccountTaskList } from "../Data/GmpmanualTaskListTable.data";
import { dateviewManualAccountData, viewManualAccountData } from "../Data/ViewManual.data";

export const setDropDownField = (apiResponse) => {
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, []);
    }

    const dropdownLists = {
        "gmpTier": filterDropDownList("Application Type"),
        "gMPTier": filterDropDownList("Application Type"),
        "gmpTier": filterDropDownList("Application Type"),
        "flagId": filterDropDownList("Manual Flag"),
    };

    const formFields = [...ManualAccountTaskList.formFields, ...CreateManualAccountData.formFields, ...viewManualAccountData.formFields];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
};

export const setFieldParameter = (apiResponse) => {
    viewManualAccountData.initialState.name = apiResponse?.fullName || '';
    viewManualAccountData.initialState.email = apiResponse?.primaryEmail || '';
    viewManualAccountData.initialState.gmpTier = apiResponse?.gmapApplicationTypeId || null;
    viewManualAccountData.initialState.appeal = apiResponse?.isAppeal || null;
    viewManualAccountData.initialState.transitioning = apiResponse?.isTransitioning || null;
    viewManualAccountData.initialState.distinguished = apiResponse?.isDistinguished || null;
    viewManualAccountData.initialState.gmaCourse = apiResponse?.isGmaCourseMembers || null;
    viewManualAccountData.initialState.internalNotes = apiResponse?.manualInternalNotes || '';
    viewManualAccountData.initialState.validFrom = apiResponse?.qualificationStartDate || null
    viewManualAccountData.initialState.validto = apiResponse?.qualificationEndDate || null
    dateviewManualAccountData.initialState.gmpNumber = apiResponse?.gmapNumber || '';
    dateviewManualAccountData.initialState.accountCreatedDate = apiResponse?.createdAt || null;
    dateviewManualAccountData.initialState.entryCreatedDate = apiResponse?.createdAt || null;
}